define('home/ReplyViewManager',[
    'underscore',
    'jquery',
    'backbone',
    'home/utils/features',
    'home/models/Post',
    'home/models/Session',
    'home/views/PostReplyView',
], function (
    _,
    $,
    Backbone,
    featureUtils,
    Post,
    Session,
    PostReplyView
) {
    'use strict';

    function ReplyViewManager(parentPostView) {
        this.view = parentPostView;
        this.model = this.view.model;

        this.listenTo(this.view, 'close', function () {
            this.stopListening();
        });
    }

    var protoFuncs = {
        /**
         * This is intended to be the only public method of this class.
         * Shows and hides the postbox (aka PostReplyView)
         * @param  {HTMLElement} replyToggleEl the link/button clicked to open the post box
         */
        toggleReplyView: function (replyToggleEl) {
            var $replyToggle = $(replyToggleEl);

            if (this.replyView) {
                this.replyView.toggle();
            } else {
                this.replyView = this.createReplyView().render();
                $replyToggle.parent().after(this.replyView.el);
            }

            if (!this.replyView._isHidden)
                this.replyView.focus();
        },

        /**
         * Convert reply box to a post view.
         * @private
         * @param  {Post} model the post just submitted
         */
        vivifyReply: function (model) {
            var view = new this.view.constructor({
                model: model,
                session: Session.get(),
            });

            this.replyView.$el.after(view.render().el);
            view.trigger('show');
            this.replyView.remove();
            this.replyView = null;
        },

        /**
         * Creates a new postbox with a new post model and sets up a listener
         * to handle when the postbox is successfully submitted (ie, when its
         * model gets successfully saved to the server)
         * @private
         * @returns {PostReplyView}
         */
        createReplyView: function () {
            var reply = new Post({
                thread: this.model.thread.id,
                parent: this.model.id,
                depth: this.model.get('depth') + 1,
                author: Session.get().user.id,
            });

            this.listenTo(reply, 'change:id', this.vivifyReply);

            return new PostReplyView({
                model: reply,
                thread: reply.thread,
                session: Session.get(),
                canUseContentEditable: featureUtils.canUseContentEditable(),
                showMediaPreviews: true,
            });
        },
    };

    _.extend(ReplyViewManager.prototype, protoFuncs, Backbone.Events);

    return ReplyViewManager;
});

